import { AnswerForm } from '../components/AnswerForm';
import type { GameModuleProps } from '../types/game';
import { validateModuleAnswer } from '../utils/answers';

export function TextAnswerModule({ module, onComplete }: GameModuleProps<'text-answer'>) {
  return <AnswerForm prompt={module.config.prompt} placeholder={module.config.placeholder}
    onValidate={(answer) => validateModuleAnswer(module, answer)}
    onSolved={(attempts) => onComplete({ success: true, attempts })} />;
}

